import { render, staticRenderFns } from "./DifficultTooltip.vue?vue&type=template&id=e4f87032&scoped=true"
import script from "./DifficultTooltip.vue?vue&type=script&lang=js"
export * from "./DifficultTooltip.vue?vue&type=script&lang=js"
import style0 from "./DifficultTooltip.vue?vue&type=style&index=0&id=e4f87032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f87032",
  null
  
)

export default component.exports